import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import Icon from './icon.gjs';
import { faUser } from '../icons/solid.js';

export default class AccountDropdownComponent extends Component {
  @service session;
  @service router;

  @action logout(e) {
    e?.currentTarget?.blur();
    this.router.transitionTo('index');
    this.session.invalidate();
  }

  @action account(e) {
    e?.currentTarget?.blur();
    this.router.transitionTo('account');
  }

  <template>
    {{#if this.session.isAuthenticated}}

      <div class="dropdown dropdown-bottom dropdown-end">
        <div tabindex="0" role="button" class="btn btn-square btn-ghost">
          <Icon role="presentation" @icon={{faUser}} />
        </div>
        <ul
          tabindex="0"
          class="dropdown-content menu z-50 rounded-box bg-base-100 text-base-content p-2 shadow-lg"
        >
          <div class="flex flex-row p-2 pb-3 items-center">
            <Icon role="presentation" @icon={{faUser}} @class="text-2xl" />
            <div class="flex flex-col flex-1 ml-4">
              <div class="font-bold">
                {{this.session.data.authenticated.user.name}}
              </div>
              <div>{{this.session.data.authenticated.user.email}}</div>
            </div>
          </div>
          <li>
            <button type="button" {{on "click" this.account}}>
              {{t "account.title"}}
            </button>
          </li>
          {{yield}}
          <div class="divider my-0" />
          <li>
            <button
              type="button"
              class="uppercase text-nowrap"
              {{on "click" this.logout}}
            >
              {{t "logout"}}
            </button>
          </li>
        </ul>
      </div>

    {{else}}

      <LinkTo @route="login" class="btn btn-ghost uppercase text-nowrap">
        {{t "login.login"}}
      </LinkTo>

    {{/if}}
  </template>
}

